export default __webpack_public_path__ + "static/media/delete.86bb3836.svg";